import TableBrowser from './browser';

export default TableBrowser;
